import React from 'react';
import Slider from 'react-slick';
import partner_1 from '../../../assets/images/patner/patner-1.png';
import partner_2 from '../../../assets/images/patner/patner-2.png';
import partner_3 from '../../../assets/images/patner/patner-3.png';
import partner_4 from '../../../assets/images/patner/patner-4.png';
import partner_5 from '../../../assets/images/patner/patner-5.png';

const partnerslider = {
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        }
    ]

}


const Partner = () => {

    return (
        <>
            <div className="patner-section-one">
                <div className="container-fluid p-0">
                    <Slider className="patner-slider-one" {...partnerslider}>
                        <div className="patner-slide-item-one">
                            <img src={partner_1} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-one">
                            <img src={partner_2} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-one">
                            <img src={partner_3} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-one">
                            <img src={partner_4} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-one">
                            <img src={partner_5} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-one">
                            <img src={partner_1} alt="patner-logo" />
                        </div>
                        <div className="patner-slide-item-one">
                            <img src={partner_2} alt="patner-logo" />
                        </div>
                    </Slider>
                </div>
            </div>

        </>
    )
}

export default Partner
